export default __webpack_public_path__ + "static/media/Muni1.b5276f8a.jpg";